export function isTokenExpired(token) {
    if (!token) {
        return true;
    }
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (!payload.exp) {
            return true;
        }
        return Date.now() >= payload.exp * 1000;
    } catch {
        return true;
    }
}

export function extractUsername(token) {
    if (!token) {
        return null;
    }
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.sub || null;
    } catch {
        return null;
    }
}
